import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { PortalProvider } from './context/PortalContext';
import { BrandThemeProvider } from './context/BrandThemeProvider';
import { Notifier } from './components/Notifier';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { AppShell } from './layout/AppShell';
import { Login } from './pages/Login';
import { PendingApproval } from './pages/PendingApproval';
import { Dashboard } from './pages/Dashboard';
import {
  Projects,
  ProjectDetail,
  PhaseDetail,
  FeatureDetail,
} from './pages/Projects';
import { ProjectDocumentsPage } from './pages/Projects/ProjectDocumentsPage';
import { ChangeRequests } from './pages/ChangeRequests';
import { Bugs } from './pages/Bugs';
import { FeatureRequests } from './pages/FeatureRequests';
import { Admin } from './pages/Admin';
import { NotFound } from './pages/NotFound';
import { ProjectIntroPublic } from './pages/ProjectIntroPublic';
import { SharedDocumentPage } from './pages/SharedDocumentPage';

/**
 * Gốc ứng dụng: Portal + Theme + Auth + Router.
 * PortalProvider phải bọc NGOÀI BrandThemeProvider, vì theme dựng theo màu
 * thương hiệu của cổng truy cập hiện tại.
 * Mọi route (trừ /login) được bọc bởi ProtectedRoute + AppShell.
 * Các trang do agent khác phụ trách hiện là placeholder tối giản.
 */
export function App(): JSX.Element {
  return (
    <PortalProvider>
      <BrandThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/pending-approval" element={<PendingApproval />} />
              <Route path="/gioi-thieu/:projectId" element={<ProjectIntroPublic type="demo" />} />
              <Route path="/huong-dan/:projectId" element={<ProjectIntroPublic type="guide" />} />
              <Route path="/shared-documents/:token" element={<SharedDocumentPage />} />

              <Route
                element={
                  <ProtectedRoute>
                    <AppShell />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:id" element={<ProjectDetail />} />
                <Route path="/projects/:id/documents" element={<ProjectDocumentsPage />} />
                <Route path="/phases/:id" element={<PhaseDetail />} />
                <Route path="/features/:id" element={<FeatureDetail />} />
                <Route path="/change-requests" element={<ChangeRequests />} />
                <Route path="/change-requests/:id" element={<ChangeRequests />} />
                <Route path="/bugs" element={<Bugs />} />
                <Route path="/bugs/:id" element={<Bugs />} />
                <Route path="/feature-requests" element={<FeatureRequests />} />
                {/* Admin/* — frontend-admin sẽ mở rộng các route con. */}
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/*" element={<Admin />} />
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Notifier />
        </AuthProvider>
      </BrandThemeProvider>
    </PortalProvider>
  );
}
